import { Global } from 'state/Global';
import { createSelector } from 'reselect';

export const selectImpersonationState = (state: Global) => state.app?.impersonation;

export const selectIsImpersonating = createSelector(
  selectImpersonationState,
  (impersonation) => impersonation?.activeSession || false
);
